import moment, { Moment } from 'moment'

import { DateRange } from 'components/DateRangePicker'

export const valueToDateString = (date?: Moment) =>
  moment.isMoment(date) ? date.format('MM/DD/YYYY') : ''

export const valuesToDateString = (dateRange: DateRange | undefined) => {
  return `${dateRange?.startDate?.format('MM/DD/YYYY')} – ${dateRange?.endDate?.format(
    'MM/DD/YYYY'
  )}`
}

export const formatRangeToFullDate = (dateRange: DateRange | undefined) => {
  if (!dateRange?.startDate || !dateRange?.endDate) return

  if (dateRange.startDate.isSame(dateRange.endDate, 'day')) {
    return dateRange?.startDate?.format('MMMM D, YYYY')
  }

  return `${dateRange?.startDate?.format('MMMM D, YYYY')} – ${dateRange?.endDate?.format(
    'MMMM D, YYYY'
  )}`
}
